import { getCurrentShrkValue } from "../FetchStats.js";
import { getCurrentRestViewer, restFetchWithNonceRecovery } from "../restFetchOptions.js";

const encodePathSegment = (value) =>
  encodeURIComponent(String(value)).replace(/%[0-9A-F]{2}/g, (match) => match.toLowerCase());

export default async function SearchAthletes(sport, keyword, options = {}) {
  const normalizedKeyword = String(keyword || "").trim().toLowerCase();
  const shrk = (options?.shrk ?? getCurrentShrkValue()).toString();
  const resultLimit = Number.isFinite(Number(options?.limit)) && Number(options.limit) > 0
    ? Math.floor(Number(options.limit))
    : 50;

  if (!sport || normalizedKeyword.length < 2) {
    return [];
  }

  const safeSport = encodePathSegment(sport);
  const safeKeyword = encodePathSegment(normalizedKeyword);
  const params = new URLSearchParams();

  params.set("viewer", getCurrentRestViewer());
  if (shrk !== "") {
    params.set("shrk", shrk);
  }
  if (resultLimit > 0) {
    params.set("limit", String(resultLimit));
  }

  const query = params.toString();
  const url = `/wp-json/athletes/v1/search/${safeSport}/${safeKeyword}${query ? `?${query}` : ""}`;

  try {
    const response = await restFetchWithNonceRecovery(url, { signal: options?.signal });

    if (!response.ok) {
      return null;
    }

    const athletes = await response.json();
    return Array.isArray(athletes) ? athletes : [];
  } catch (error) {
    if (error?.name === "AbortError") {
      return [];
    }
    console.error("Error searching athletes:", error);
    return null;
  }
}
